import { useAuth } from "hooks/useAuth";
import React, { FC, ReactElement } from "react";
import { useLocation, Navigate } from "react-router";
import { CommonInterface } from "utilities/interfaces";

const Auth: FC<CommonInterface> = ({ children }): ReactElement => {
  const isAuthenticated = useAuth();
  const Location = useLocation();

  if (!isAuthenticated) {
    return <Navigate to="/login" state={{ from: Location }} replace />;
  } else {
    return <>{children}</>;
  }
};

export default Auth;
